@import (reference) '../../../../../../constants/spacing.module.less';

.content {
  margin: @space-24;
}

.description {
  margin-bottom: @space-16;
  line-height: 1.5;
}

.radio-option {
  padding: @space-12 0;
}
